module.exports = __webpack_public_path__ + "img/features-img3.0ca0c37f.png";